import React from "react";
import "./TransactionSummary.scss"
import { fromCentsToPounds } from "../../../helpers/money";


function TransactionSummary({ transaction }) {

    const date = new Date(parseInt(transaction?.created) * 1000); // Multiply by 1000 for milliseconds

    // Format the date
    const formattedDate = date.toLocaleDateString('en-GB', {
        year: 'numeric',   // Full numeric year (e.g., 2023)
        month: 'short',    // Short month name (e.g., Mar)
        day: '2-digit'     // Two-digit day (e.g., 23)
    });

    const withdrawal = transaction?.amount || 0
    const fees = (transaction?.metadata?.applicationFees || 0) * 0.10
    const total = withdrawal + fees

    return (
        <div className="transaction-container py-16">
            <div className="d-flex aic jcsb">
                <div className="total-amount">{fromCentsToPounds(total)}</div>
                <div className="date">{formattedDate}</div>
            </div>
            <div className="details">
                {fromCentsToPounds(withdrawal)} withdrawal + {fromCentsToPounds(fees)} Fee
            </div>
        </div>
    );
}

export default TransactionSummary;
